import Typography from '@mui/material/Typography';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import createFormTextField from '../../../../components/FormTextFields/FormTextFields';

interface DaysBackFieldProps {
  canEdit: boolean;
  register: UseFormRegister<FieldValues>;
  errors?: FieldErrors;
}

function DaysBackField({ canEdit, register, errors }: DaysBackFieldProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      {createFormTextField(
        {
          name: 'daysBack',
          variant: 'standard',
          inputType: 'number',
          label: t('inventory.inventoryValuationSettings.daysBackLabel'),
          disabled: !canEdit,
          dataTestId: 'days-back-field',
          gridProps: { xs: 12, sm: 6, md: 4 },
          inputProps: { min: 1, max: 1000 },
          validationName: 'daysBack',
          errors,
        },
        { t, tKey: '' },
        register
      )}
      <Typography variant='body2' color='textSecondary'>
        {t('inventory.inventoryValuationSettings.daysBackFieldDescription')}
      </Typography>
    </Grid>
  );
}

DaysBackField.defaultProps = {
  errors: undefined,
};

export default DaysBackField;
